var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-breadcrumb',{staticClass:"bread_crumbs"},_vm._l((_vm.project.breadCrumb),function(item,index){return _c('b-breadcrumb-item',{key:index,class:_vm.getClassName(item),style:({
      '--breadcrumb-color': _vm.isActive(item) ? item.color : ''
    }),attrs:{"href":("/projects/" + (_vm.project.id) + "/orders/estimates")}},[_vm._v(_vm._s(item.name))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }